import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useDispatch } from 'react-redux';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ColorConstants from '../../../../defaults/ColorConstants';

const useStyles = makeStyles(() => ({
  thinFormControl: {
    margin: 15,
    marginLeft: 10,
    minWidth: 120,
    width: '30%'
  },
  formControl: {
    margin: 15,
    minWidth: 120,
    width: '90%'
  },
  wideFormControl: {
    margin: 15,
    minWidth: 230,
    width: '90%'
  },
  select: {
    color: ColorConstants.GrayAlien,
    backgroundColor: ColorConstants.WhiteAlien,
    '&.MuiSelect-icon': {
      color: ColorConstants.GrayAlien,
    }
  },
  inputLabel: {
  },
}));

const theme = createTheme({
  overrides: {
    MuiOutlinedInput: {
      root: {
        '&$focused $notchedOutline': {
          //border on focus
          borderColor: ColorConstants.BlueAlien,
          border: '2px solid'
        },
      },
    },
    MuiSelect: {
      icon: {
        color: ColorConstants.GrayAlien
      },
      root: {
        //padding: 16
      }
    },
    MuiInputLabel: {
      root: {
        // fontSize: 14
      }
    }
  },
});

export default function DropdownFilter({ filter, typeSelectionChange, setValue, value, codedValues, name, wide, useThinStyle, dropdownChanged }) {
  const [dropdownValues, setDropdownValues] = useState(filter.domain.codedValues === null ? [] : filter.domain.codedValues);
  const dispatch = useDispatch();

  useEffect(() => {
    if(codedValues){
      setDropdownValues(codedValues);
    }
  }, [codedValues])

  const handleChange = (event) => {
    if(filter.name === "Approvals" && dropdownChanged) {
      dropdownChanged(event.target.value);
    }
    dispatch(setValue(event.target.value));
    if (typeSelectionChange) {
      typeSelectionChange(event.target.value);
    }
  };
  const classes = useStyles();

  return (
    <div>
      <ThemeProvider theme={theme}>
        <FormControl variant="outlined" className={wide ? classes.wideFormControl : useThinStyle ? classes.thinFormControl : classes.formControl}>
          <InputLabel className={classes.inputLabel} id="language-selector-input-label">
            {name ?? filter.name}
          </InputLabel>
          <Select
            className={classes.select}
            labelId="lenguage-selector-label"
            id="lenguage-selector"
            onChange={handleChange}
            label={name ?? filter.name}
            value={value ?? ""}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {dropdownValues.map((val, i) => (
              <MenuItem value={val.code} key={i}>{val.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </ThemeProvider>
    </div>
  );
}

